import { useEffect, useState } from "react"
import { Input } from "@/components/ui/input"

interface MoneyInputProps {
  cents: number | ""
  onChangeCents: (cents: number | "") => void
  id?: string
  className?: string
  placeholder?: string
}

// Euro-facing input that stores its value as integer cents. Keeps a local text
// buffer so decimal typing ("50." / "50,5") doesn't get clobbered by the
// controlled value, while still syncing when the upstream cents change
// (e.g. server-provided initial values on edit / failed submit).
export default function MoneyInput({
  cents,
  onChangeCents,
  id,
  className,
  placeholder,
}: MoneyInputProps) {
  const [text, setText] = useState(centsToText(cents))

  useEffect(() => {
    if (textToCents(text) !== cents) {
      setText(centsToText(cents))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cents])

  return (
    <Input
      id={id}
      type="text"
      inputMode="decimal"
      className={className}
      placeholder={placeholder ?? "0,00"}
      value={text}
      onChange={(e) => {
        const next = e.target.value
        setText(next)
        onChangeCents(textToCents(next))
      }}
    />
  )
}

function centsToText(cents: number | ""): string {
  return cents === "" || cents == null ? "" : (cents / 100).toFixed(2)
}

function textToCents(text: string): number | "" {
  const cleaned = text.replace(",", ".").trim()
  if (cleaned === "") return ""
  const n = parseFloat(cleaned)
  return Number.isNaN(n) ? "" : Math.round(n * 100)
}
